import { LAST_SELECTED_KEY } from "../../../app/state/storageObjectSlice/constants";
import { APP_MULTI_USER_API } from "../../../services/api/constants";
import type { AuthUserType } from "../../../services/api/methodsTypes";

export function initMultiUserStorage() {
  if (localStorage.getItem(APP_MULTI_USER_API) === null) {
    localStorage.setItem(APP_MULTI_USER_API, JSON.stringify([]));
  }
}

export const multiUserApi = {
  parseToArray(): AuthUserType[] {
    const item = localStorage.getItem(APP_MULTI_USER_API);
    return item ? JSON.parse(item) : [];
  },

  getActiveUser(): AuthUserType | undefined {
    const users = this.parseToArray();
    return users.find((item) => item.isActive === true);
  },

  getUserKey(key: Exclude<keyof AuthUserType, "isActive">): string {
    const user = this.getActiveUser();
    return user?.[key] ?? "";
  },

  checkUserValue(key: keyof AuthUserType, value: string | boolean): boolean {
    const users = this.parseToArray();
    return users.some((item) => item[key] === value);
  },

  toggleUser(value: string): void {
    const users = this.parseToArray();
    users.forEach((item) => {
      item.isActive = item.user_name === value;
    });
    localStorage.removeItem(LAST_SELECTED_KEY);
    localStorage.setItem(APP_MULTI_USER_API, JSON.stringify(users));
  },

  addUser(user: AuthUserType): void {
    const users = this.parseToArray();
    const existingIndex = users.findIndex(
      (u) => u.user_name === user.user_name,
    );

    if (existingIndex >= 0) {
      users[existingIndex] = user;
      users.forEach((u, i) => {
        if (i !== existingIndex) u.isActive = false;
      });
    } else {
      users.forEach((u) => (u.isActive = false));
      users.push({ ...user, isActive: true });
    }

    localStorage.setItem(APP_MULTI_USER_API, JSON.stringify(users));
  },

  setUserKey(
    users: AuthUserType[],
    key: keyof AuthUserType,
    value: string | boolean,
  ): string {
    const updated = users.map((item) =>
      item.isActive ? { ...item, [key]: value } : item,
    );
    return JSON.stringify(updated);
  },

  removeUser(): void {
    const users = this.parseToArray();
    if (users.length <= 1) {
      localStorage.setItem(APP_MULTI_USER_API, JSON.stringify([]));
    } else {
      const inactive = users.filter((u) => !u.isActive);
      if (inactive.length > 0) {
        inactive[0].isActive = true;
        localStorage.setItem(APP_MULTI_USER_API, JSON.stringify(inactive));
      } else {
        localStorage.setItem(APP_MULTI_USER_API, JSON.stringify([]));
      }
    }
  },

  removeUserKey(keys: string[]): void {
    const users = this.parseToArray();
    const updated = users.map((item) => {
      if (item.isActive) {
        const filtered = Object.fromEntries(
          Object.entries(item).filter(([k]) => !keys.includes(k)),
        );
        return { ...filtered, isActive: true };
      }
      return item;
    });
    localStorage.setItem(APP_MULTI_USER_API, JSON.stringify(updated));
  },
};
